module.exports = __webpack_public_path__ + "img/cert.223b4999.jpg";